import { ProgressBar } from "react-bootstrap";

interface PdfProgressBarProps {
  progress: number;
}

const PdfProgressBar = ({ progress }: PdfProgressBarProps) => (
  <div className="exam-container__form">
    <ProgressBar
      animated
      variant="success"
      now={progress}
      label={`個票PDF生成中 ${progress}%`}
    />
  </div>
);

export default PdfProgressBar;
